import { render, staticRenderFns } from "./ChequeAsignadoPage.vue?vue&type=template&id=89a1271a"
import script from "./ChequeAsignadoPage.js?vue&type=script&lang=js&external"
export * from "./ChequeAsignadoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports